import client from '../../providers/fetchClient'

export const getIndications = id => client.get(`/v3/my-indications?user_id=${id}`)

export const getIndicationsShow = id => client.get(`/v3/my-indications/${id}`)

export const getIndicationsCSV = (id, configs) =>
  client.get(`/v3/my-indications?user_id=${id}&export_as_csv=true`, configs)
